import { useAdvancedMode } from "../lib/plain-language";

/**
 * Liga/desliga a ÁREA TÉCNICA. Desligado (padrão) a interface fala em
 * linguagem do cliente; ligado, aparecem arquivos, diferenças e detalhes.
 */
export default function AdvancedModeToggle({ className = "" }: { className?: string }) {
  const [advanced, setAdvanced] = useAdvancedMode();

  return (
    <label className={`flex items-center gap-2 text-xs text-ink-muted ${className}`}>
      <input
        type="checkbox"
        checked={advanced}
        onChange={(event) => setAdvanced(event.target.checked)}
        className="h-3.5 w-3.5 rounded border-line"
      />
      Detalhes técnicos
    </label>
  );
}
